export default __webpack_public_path__ + "static/media/hola.fd40ad58.png";